import cjson from 'compressed-json';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { JdDataService } from 'src/app/jd-data.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Component({
    selector: 'app-report-diversity',
    templateUrl: './report-diversity.component.html',
    styleUrls: ['./report-diversity.component.scss'],
    standalone: false
})
export class ReportDiversityComponent implements OnInit {

  constructor(
    private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService, private router: Router,
    private filterDataHandlerService: FilterDataHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private hashService: HashService,
    private talentInsightsService: TalentInsightsService,
    private fusionChartService: FusionChartsService,
    private jdService: JdDataService,
    private route: ActivatedRoute
  ) {

    const statemanagementSub = this.location.subscribe((p) => {
                const urlParams = new URLSearchParams(p.url.split('?')[1]);
                const filterKey = urlParams.get('filter');
                if (filterKey) {
                  const cacheRequest = localStorage.getItem(filterKey);
                  if (cacheRequest) {
                    const filterData = cjson.decompress(JSON.parse(cacheRequest));
                    this.filterDataHandlerService.setFilterData(filterData);
                  }
                }
                this.setUpdatedData(null);
              });
  }
  companyDetails: any;
  currentCompanyName: string;
  genderChart: any = [];
  totalFunctionResultCount: number = 0;
  dropDownMenu: any = [];
  selectedIndustries: any;
  genderChartByIndustries: any;
  startIndexForDiversity: number = 0;
  previousDiversityData: any = [];
  previousDiverityFunctions: any[] = [];
  diversityTable: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['key', 'doc_count', 'male', 'graph', 'female'];
  aggregatescount: number = 50;
  isViewMore: boolean = true;

  showGenderDropdownChartLoader: Boolean = true;
  showGenderChartLoader: Boolean = true;
  showTitlestLoader: Boolean = true;
  jobTitleData: any[] = []
  totalResultCount: any;
  diversityJobTitles: any[] = []
  pagination: boolean = true;
  pageSize = 10;
  start: number = 0;
  end: number = 10;
  currentPage = 1;
  totalCountPage = 0;
  talentfilterdata:any = {};
  totalCount:number = 0;
  jobtitlearray: any[]=[];
  jobtitles: any
  @ViewChild('titlesort') titlesort: MatSort;
  isApiCalled: boolean = false;
  diversitysubscription: Subscription;
  insightsExportSubscription: Subscription = null;
  subscriptions: Array<Subscription> = [];

  /**Sorted data collection of shown pages */
  diversitySortData: any = [];
  jobTitleKey: any;

    /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
    tableHeaderObj = {
      "Titles" : "Titles",
      "TalentCount": "Talent Count",
      "Men" : "Men",
      "DiversityRatio": "Diversity Ratio",
      "Women": "Women",
    }

    /**
     * Used to send as payload for export pdf.
     * Use key that need to be shown in pdf.
     * Must follow correct order as used in HTML file
     */
    tableHeaderName: string[] = [];

  diversitydataAI: any = {};

  /** Nationality chart */
  nationalityChart: any = [];

  /**Aggregate for nationality type is pending or not */
  isNationalityPending: boolean = false;

  /** Ethnicity chart */
  ethnicityChart : any = [];

  /**Aggregate for ethnicity type is pending or not */
  isEthnicityPending: boolean = false;
  filters: any;
  isComingFromJD: boolean = false;
  isComingFromNLSearch: boolean = false;

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if(!hasEUPSAccess )
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
   if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;

    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.DIVERSITY) {
        this.setUpdatedData();
      }
    });
    this.subscriptions.push(jdUpdateEvent);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.getGenderChart();
    this.getDropDownMenu();
    this.getJobTitles();
    // this.getNationalityData();
    // this.getEthnicity();
    this.personSearchService.setTalentinsightsFilterAI(this.talentfilterdata);

  }

  getGenderChart() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.showGenderChartLoader = false;
      this.totalFunctionResultCount = response.data.aggregations.gender[0]?.doc_count + response.data.aggregations.gender[1]?.doc_count;
      const data = response.data.aggregations.gender;
      this.genderChart = this.fusionChartService.genderDiversityChart(data);
    });
  }


  getDropDownMenu() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_industry';
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.showGenderDropdownChartLoader=false;
      this.dropDownMenu = response.data.aggregations[aggReq.aggregatetype].length > 0 ? response.data.aggregations[aggReq.aggregatetype].map(x => x.key):[];
      const filterSelectedPsuedoEvent = {
        target: {
          value : ""
        }
      };
      if (aggReq?.industries?.length) {
        filterSelectedPsuedoEvent.target.value = aggReq.industries[0];
      }
      this.filterselected(filterSelectedPsuedoEvent);
    });
  }

  filterselected(event) {
    if( event.target.value == "null" || event.target.value == "undefined" || event.target.value == "All" || event.target.value == ""){
      this.selectedIndustries = null;
    } else {
      this.selectedIndustries = event.target.value;
    }
    this.getGenderChartByIndustries();
  }

  getGenderChartByIndustries() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "gender";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (!!this.selectedIndustries) {
      aggReq.industries = [this.selectedIndustries];
    }
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {

      const male = response.data.aggregations.gender[0]?response.data.aggregations.gender[0]:0
      const female = response.data.aggregations.gender[1]?response.data.aggregations.gender[1]:0
      this.totalFunctionResultCount = male+female;
      const data = response.data.aggregations.gender;

      this.genderChartByIndustries = this.fusionChartService.genderDiversityChart(data);
    });
  }

  /**
   * Get Nationality data from aggregate and show fusion chart
   */
  getNationalityData() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "nationality";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();

    this.isNationalityPending = true;
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.isNationalityPending = false;
      const nationalityData = response?.data?.aggregations?.nationality || [];

      this.nationalityChart = this.fusionChartService.nationalityChart(nationalityData, response?.data?.totalresultscount);

      const nationalityDataAi = this.nationalityChart.data.map(x => ({
        key: x.label,
        doc_count: x.value + '%'
      }));

      this.getdiversitydataai(nationalityDataAi, 'nationality');
    })
  }

  /**
  * Get Ethnicity data from aggregate and show fusion chart
  */
  getEthnicity() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "ethnicity";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();

    this.isEthnicityPending = true;
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {

      this.isEthnicityPending = false;

      const ethnicityData = response?.data?.aggregations?.ethnicity || [];

      this.ethnicityChart = this.fusionChartService.ethnicityChart(ethnicityData, response?.data?.totalresultscount);

      const ethnicityDataAi = this.ethnicityChart.data.map(x => ({
        key: x.label,
        doc_count: x.value + '%'
      }));

      this.getdiversitydataai(ethnicityDataAi, 'ethnicity');
    })
  }

  getJobTitles(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      if(response && response.data && response.data.aggregations && response.data.aggregations.current_jobtitle){
        this.isApiCalled = true;

        this.totalResultCount = response.data.totalresultscount;

        const tempData = response.data.aggregations.current_jobtitle;
        this.diversitySortData = tempData;
        this.jobTitleKey = _.pluck(tempData, 'key')
        this.totalCount = tempData.length;
        this.jobTitleData = tempData.slice(this.start, this.end);
        this.jobtitles = new MatTableDataSource(this.jobTitleData);
        this.jobtitles.sort = this.titlesort;
        this.getGenderRatio();
        this.manualSort();
        this.getdiversitydataai(tempData);
      }
    })
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if (this.aggregatescount / this.pageSize <= index) {
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getJobTitles();
    }
    else {
      this.manualSort();
    }
  }


  // TODO : Need to confirm how we can handle the aggregate type for this method.
  getGenderRatio(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-gender";
    aggReq.startindex = 0;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {

      if (response && response.data && response.data.aggregations && response.data.aggregations['current_jobtitle-gender']) {
        const tempData = response.data.aggregations['current_jobtitle-gender'];

        this.diversitySortData.map(res => {
          const gender = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
          if (gender && gender.gender && gender.gender.length > 0) {
            const femalecount = gender.gender.filter(x => x.key == "female") && gender.gender.filter(x => x.key == "female").length > 0 ? gender.gender.filter(x => x.key == "female")[0].doc_count : 0;
            const malecount = gender.gender.filter(x => x.key == "male") && gender.gender.filter(x => x.key == "male").length > 0 ? gender.gender.filter(x => x.key == "male")[0].doc_count : 0;
            const totalgendercount = femalecount + malecount
            res.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount) : 0

            res.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount) : 0;
          }
          return res;
        })
        this.getdiversitydataai(this.diversitySortData);
      }
    })
  }

  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(2);
  }

  maleDataPercent(gender) {
    if (gender[0]?.key == "male") {
      let totalGender = 0
      gender.map((res) => {
        totalGender = totalGender + res.doc_count;
      })
      const percent = (gender[0].doc_count * 100) / totalGender;
      return percent ? percent.toFixed(0) : 0;
    } else {
      return 0;
    }


  }

  femaleDataPercent(gender) {
    if (gender[1]?.key == "female") {
      let totalGender = 0
      gender.map((res) => {
        totalGender = totalGender + res.doc_count;
      })
      const percent = (gender[1].doc_count * 100) / totalGender
      return percent ? percent.toFixed(0) : 0;
    } else {
      return 0;
    }
  }

  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  manualSort() {
    this.reSortArr(this.titlesort);
  }

  reSortArr(sort: MatSort) {
    const data = this.diversitySortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.jobTitleData = data.slice(this.start, this.end);
      this.jobtitles = new MatTableDataSource(this.jobTitleData);
      this.jobtitles.sort = this.titlesort;
      return;
    }
    this.diversitySortData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'male': return this.compare(a.male, b.male, isAsc);
        case 'female': return this.compare(a.female, b.female, isAsc);
        default: return 0;
      }
    });

    this.jobTitleData = this.diversitySortData.slice(this.start, this.end);
    this.jobtitles = new MatTableDataSource(this.jobTitleData);
    this.jobtitles.sort = this.titlesort;
  }

  private compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
  * Handel Redirection to person search listing
  * @param type
  * @param key
  */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;
 this.filters = this.filterDataHandlerService.fetchFilterData;

    const redirectFilters: Partial<FilterParams> = {
      insightsFilterData: this.filters,
    };

   switch (type) {
      case 'jobtitle': redirectFilters['mandatoryjobtitles'] = [key]; break;
    }

     const aggReq = this.aggService.getRequestWithFilters();
         if (aggReq?.continentstobeincluded) {
           redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
         }
         // if (aggReq?.nlsearchquery) {
         //   redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
         // }

         const uniqueKey = this.hashService.generateUniqueHash();
         localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

         // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
         // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
         // that window.open() clones into the new tab.
         const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

         let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

         if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
           url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
         }

         window.open(url, '_blank');
  }

  getdiversitydataai(data, type='') {
    if(type === ''){
      let diversitydata: any;
      diversitydata = data.map(x => {
        let res: any = {};
        res['Titles'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Men'] = x.male+'%';
        res['Women'] = x.female+'%';
        return res;
      })
      this.diversitydataAI['functions'] = diversitydata;
    }
    if(type === 'nationality'){
      this.diversitydataAI['nationality'] = data;
    }
    if(type === 'ethnicity'){
      this.diversitydataAI['ethnicity'] = data
    }
  }

  /**
   * Convert to titlecase
   * @param stringName
   */
  convertToTitleCase(stringName){
    stringName = stringName.toLowerCase().split(' ');
    for(let i = 0;i<stringName.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName.join(' ');
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.DIVERSITY) return;

    // gender chart config
    const genderChart = { renderAt: 'genderDiversityChart', type: 'column2d', dataSource: __.cloneDeep ({ ...this.genderChart }) };
    genderChart['type'] = genderChart['dataSource']['type'];
    genderChart['dataSource']['chart']['showLabels'] = "1";
    genderChart['dataSource']['chart']['showValues'] = "1";
    genderChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    delete genderChart['dataSource']['type'];
    delete genderChart['dataSource']['width'];
    delete genderChart['dataSource']['chart']['width'];
    delete genderChart['dataSource']['height'];
    delete genderChart['dataSource']['chart']['height'];
    delete genderChart['dataSource']['chart']['renderAt'];

    // gender by industry chart config
    const genderByIndustriesChart = Object.assign({}, { renderAt: 'genderDiversityByIndustryChart', dataSource: __.cloneDeep({ ...this.genderChartByIndustries }) });
    genderByIndustriesChart['type'] = genderByIndustriesChart['dataSource']['type'];
    genderByIndustriesChart['dataSource']['chart']['showLabels'] = "1";
    genderByIndustriesChart['dataSource']['chart']['showValues'] = "1";
    genderByIndustriesChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
    delete genderByIndustriesChart['dataSource']['type'];
    delete genderByIndustriesChart['dataSource']['width'];
    delete genderByIndustriesChart['dataSource']['chart']['width'];
    delete genderByIndustriesChart['dataSource']['height'];
    delete genderByIndustriesChart['dataSource']['chart']['height'];
    genderByIndustriesChart['dataSource']['chart']['legendPosition'] = 'bottom';


  /**Dynamic headers name, used to send in backend as well, Order will remains same as used in HTML file */
  this.tableHeaderName = [this.tableHeaderObj["Titles"], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["Men"], this.tableHeaderObj["Women"]];




    const payloadForInsightsExport = {
      tab: 'diversity',
      totalresultcount: this.totalResultCount,
      chartdetails: [genderChart, genderByIndustriesChart],
      selectedIndustry: this.convertToTitleCase(this.selectedIndustries || ''),
      diversityByTitles: this.diversitySortData,
      tableHeader: this.tableHeaderName
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
